/* COD rows (M6 workspace) + cycle config (verbatim generator from mockup core.js). */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_COD_ROWS = SUPPLY_DATA.codRows
export const DUMMY_COD_CONFIG = SUPPLY_DATA.codConfig
